import React from 'react'
import classes from './Divider.module.css';

const Divider = () => {
  return (
    <span className={classes.divider}></span>
  )
}

export default Divider